const debounce = (func, delay) => {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
};

class MobileSlider extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      mainSwiperClass: '.main-swiper',
      thumbsSwiperClass: '.thumbs-swiper'
    };
    this.mainSwiperInstance = null;
    this.thumbsSwiperInstance = null;
  }

  connectedCallback() {
    this._debouncedCheckScreenWidth = debounce(this._checkScreenWidth.bind(this), 200);
    window.addEventListener("resize", this._debouncedCheckScreenWidth);
    this._checkScreenWidth();
  }

  _initSlider() {
    const mainSliderElement = this.querySelector(this.selectors.mainSwiperClass);
    const thumbsSliderElement = this.querySelector(this.selectors.thumbsSwiperClass);

    if (mainSliderElement && thumbsSliderElement) {
      this.thumbsSwiperInstance = new Swiper(thumbsSliderElement, {
        slidesPerView: 3,
        spaceBetween: 5,
        centeredSlides: false,
        slideToClickedSlide: true
      });

      this.mainSwiperInstance = new Swiper(mainSliderElement, {
        slidesPerView: 1.07,
        spaceBetween: 16,
        centeredSlides: false,
        thumbs: {
          swiper: this.thumbsSwiperInstance
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        }
      });
    }
  }

  _destroySlider() {
    if (this.mainSwiperInstance) {
      this.mainSwiperInstance.destroy(true, true);
      this.mainSwiperInstance = null;
    }
    if (this.thumbsSwiperInstance) {
      this.thumbsSwiperInstance.destroy(true, true);
      this.thumbsSwiperInstance = null;
    }
  }

  _checkScreenWidth() {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 768 && !this.mainSwiperInstance) {
      this._initSlider();
    } else if (screenWidth > 768 && this.mainSwiperInstance) {
      this._destroySlider();
    }
  }
}

customElements.define("mobile-slider", MobileSlider);
